module.exports = __webpack_public_path__ + "static/img/40.2a9278b8.png";